import { useEffect } from 'react';

export default function Nav() {
  useEffect(() => {
    const onScroll = () => {
      document.getElementById('mainNav').classList.toggle('scrolled', window.scrollY > 50);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav id="mainNav">
      <div className="nav-i">
        <a href="https://koderspedia.com/" className="logo" target="_blank" rel="noopener noreferrer">
          <div className="logo-k">
           <img src='https://koderspedia.com/wp-content/uploads/2023/12/logo-header-2.svg'></img>
          </div>
        </a>
        <a href="https://koderspedia.com/" className="btn-nav" target="_blank" rel="noopener noreferrer">
          <span>Get Started</span>
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M2 7h10M7 3l4 4-4 4" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </a>
      </div>
    </nav>
  );
}
